import { white, robotoRegular, scarpaGray200, scarpaGray25, scarpaGray500, scarpaGray800, scarpaGray100, spanishViridian600 } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.div`
    background: ${white};
    border-radius: 10px;
    padding: 0;
    margin-bottom: 40px;
    .retention-tabs {
        margin: 0;
    }
    .container {
        padding: 0px;
    }
    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 24px 0px;
    }

    @media ${({ theme }) => theme.screenSizes.laptop} {
        margin: 0 auto;
        padding: 16px 24px;
    }
`;

export const Container = styled.div`
    margin: 24px 0;
    padding: 16px;
    @media ${({ theme }) => theme.screenSizes.tablet} {
        border: 1px solid ${scarpaGray200};
        border-radius: 4px;
    }

    .header_table {
        background-color: #fafafa;
        padding: 0 16px;
        margin: 16px 0px;

        :first-of-type {
            margin-top: 0px;
        }
    }
`;

export const LayoutCardsColumns = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 8px;

    .containerLabel,
    .container {
        display: flex;
        gap: 8px;
        align-items: center;
        font-size: 12px;
        line-height: 20px;
        font-family: ${robotoRegular};
        color: ${scarpaGray500};
        text-align: left;

        &.gap-10 {
            gap: 10px;
            padding: 4px 8px;
        }
        &.gap-16 {
            gap: 10px;
            padding: 6px 8px;
        }
        &.space-between {
            justify-content: space-between;
        }

        b {
            color: ${scarpaGray800};
        }
    }

    .containerLabel:nth-of-type(even) {
        background-color: ${scarpaGray25};
    }
    .no-flex {
        display: block;
    }
    .label {
        font-size: 10px;
        letter-spacing: 2px;
        line-height: 10px;
        text-transform: uppercase;
        font-weight: 600;
        font-family: ${robotoRegular};
        color: ${scarpaGray500};
        text-align: left;
        &.green {
            color: ${spanishViridian600};
        }
        &.single-line {
            white-space: nowrap;
        }
    }
    .label-status {
        border-radius: 4px;
        background: ${scarpaGray100};
        color: ${scarpaGray800};
        padding: 0px 6px;
        font-weight: 600;

        &.mayus {
            text-transform: uppercase;
            width: 100%;
            font-size:10px;
            line-height: 10px;
            padding: 4px 6px 4px 6px;
        }
    }
    @media ${({ theme }) => theme.screenSizes.laptop}{
        .space-between {
        justify-content: space-between;
    }
    }
`;

export const WrapperButton = styled.div`
    max-width: 100%;
    display: flex;
    gap: 24px;
    button {
        width: 100%;
        max-width: 200px;
        margin: auto;
    }
`;

export const TextModal = styled.div`
    font-size: 22px;
    text-align: center;
    margin: 32px;
`
